import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import CheckoutProvider from '../components/checkout/CheckoutProvider';
import CheckoutContent from './CheckoutContent';
import { assessments } from '../data/assessments';

export default function CheckoutPage() {
  const { assessmentId } = useParams();
  const assessment = assessments.find(a => a.id === assessmentId);

  if (!assessment) {
    return <div>Assessment not found</div>;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <CheckoutProvider>
          <CheckoutContent assessment={assessment} />
        </CheckoutProvider>
      </div>
    </div>
  );
}